import { Icon } from '@ps/isp-web-component-library';
import type { MyBetPart } from '@ps/isp-web-services-types';
import { Translation } from '@ps/web-shared-components';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import PriceBoost from '@swf/generated/sports-icons/priceBoost';
import { Odds } from '@swf/sports/components';
import { isOddsBoostMarket } from '@swf/sports/utils/isOddsBoostMarket';

import { TXTWCL_EW, TXTWCL_SP, TXTWCL_odds_boost } from './OddsContent.messages.json';
import styles from './OddsContent.scss';

interface OddsTagProps {
  hasPrefix?: boolean;
  part: MyBetPart;
  isVisibleStartingPrice: boolean;
}

const OddsContent = ({ part, hasPrefix, isVisibleStartingPrice }: OddsTagProps) => {
  const { formatMessage } = useRegulatoryIntl();
  const hasEachWay = part.eachwayFactor && part.eachwayPlaces;

  return (
    <>
      {hasPrefix && '@ '}
      {isVisibleStartingPrice && <Translation {...TXTWCL_SP} />}
      {!isVisibleStartingPrice && part.odds && <Odds {...part.odds} />}
      {hasEachWay && (
        <>
          {` `}
          <Translation {...TXTWCL_EW} />
        </>
      )}
      {isOddsBoostMarket(part.marketType) && (
        <Icon
          className={styles.oddsboostIcon}
          icon={PriceBoost}
          label={formatMessage(TXTWCL_odds_boost)}
          size="xs"
        />
      )}
    </>
  );
};

export default OddsContent;
